import { ShieldCheck, Briefcase, MessageSquareQuote, ClipboardCheck, Users, CheckCircle2 } from "lucide-react";
import FadeUp from "@/components/landing/FadeUp";
import { VERIFICATION } from "./content";
import { Card, SectionHeading } from "./Primitives";

const icons = [ShieldCheck, Briefcase, MessageSquareQuote, ClipboardCheck, Users];

const VerificationReport = () => (
    <Card
        data-testid="verification-report"
        className="p-5 md:p-6 bg-white shadow-[0_30px_80px_-50px_rgba(11,15,25,0.3)]"
    >
        <div className="flex items-start justify-between gap-4">
            <div>
                <p className="text-[11px] font-semibold tracking-[0.12em] uppercase text-hire-muted">
                    Candidate verification report
                </p>
                <p className="mt-1 text-sm font-semibold text-hire-ink">Candidate ref · AVC-XXXX</p>
            </div>
            <span className="rounded-md bg-brand-blue-soft text-brand-blue px-2 py-1 text-[11px] font-semibold">
                Illustrative example
            </span>
        </div>
        <ul className="mt-5 divide-y divide-hire-line">
            {VERIFICATION.cards.map((c, i) => {
                const Icon = icons[i];
                return (
                    <li key={c.title} className="flex items-center gap-3 py-3">
                        <span className="h-8 w-8 rounded-lg bg-hire-bg grid place-items-center text-hire-muted shrink-0">
                            <Icon className="h-4 w-4" />
                        </span>
                        <span className="flex-1 text-[14px] font-medium text-hire-ink">{c.title}</span>
                        <span className="inline-flex items-center gap-1.5 rounded-full bg-[#ECFDF5] text-[#047857] px-2.5 py-1 text-[11.5px] font-semibold">
                            <CheckCircle2 className="h-3.5 w-3.5" /> {c.status}
                        </span>
                    </li>
                );
            })}
        </ul>
        <div className="mt-4 rounded-xl bg-hire-bg p-3 text-[12px] text-hire-muted leading-relaxed">
            Reports summarise completed checks for each shortlisted professional. No personal data is shown here.
        </div>
    </Card>
);

export const Verification = () => (
    <section
        id="verification"
        data-testid="verification-section"
        className="section-pad bg-hire-ink text-white"
    >
        <div className="container-page">
            <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
                <div className="lg:col-span-7">
                    <SectionHeading
                        light
                        eyebrow="Candidate verification"
                        title={VERIFICATION.heading}
                        sub={VERIFICATION.sub}
                        testId="verification-heading"
                    />
                    <div className="mt-12 grid sm:grid-cols-2 gap-4">
                        {VERIFICATION.cards.map((c, i) => {
                            const Icon = icons[i];
                            return (
                                <FadeUp key={c.title} delay={i * 0.05}>
                                    <div
                                        data-testid={`verification-card-${i + 1}`}
                                        className="h-full rounded-2xl border border-white/10 bg-white/[0.04] p-6 transition-colors hover:bg-white/[0.07]"
                                    >
                                        <span className="h-10 w-10 rounded-xl bg-brand-blue grid place-items-center text-white">
                                            <Icon className="h-5 w-5" />
                                        </span>
                                        <h3 className="mt-5 text-[16px] font-semibold text-white leading-snug">{c.title}</h3>
                                        <p className="mt-2 text-[14px] text-white/65 leading-relaxed">{c.body}</p>
                                    </div>
                                </FadeUp>
                            );
                        })}
                    </div>
                </div>
                <div className="lg:col-span-5 lg:sticky lg:top-28">
                    <FadeUp delay={0.15}>
                        <VerificationReport />
                    </FadeUp>
                </div>
            </div>
            <FadeUp delay={0.1}>
                <p
                    data-testid="verification-closing"
                    className="mt-14 md:mt-20 max-w-3xl text-xl md:text-2xl font-semibold text-white leading-snug text-balance"
                >
                    {VERIFICATION.closing}
                </p>
            </FadeUp>
        </div>
    </section>
);

export default Verification;
